import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./GlobalServiceMidBanner.css";
import Modal from "../../../Pages/ModalForm";

const GlobalServiceMidBanner = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => {
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  return (
    <>
      <section className="upgrade-section mt-5 pt-5 pb-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h1 className="headings text-white mt-2 lh-base">
                <span>Want to Join Us </span>as Our Travel Partner and Upgrade
                Your Travel Experience?
              </h1>
              <div className="carouselCaption mt-md-3 mt-xxl-3 upgrade-btn">
                <button
                  className="btn fs4  bg-transparent text-white text-uppercase leeter traveler-btn-weight"
                  type="submit"
                  onClick={handleShow}
                >
                  BE OUR TRAVEL PARTNER
                </button>
              </div>
              <Modal show={showModal} handleClose={handleClose} />
            </div>
            <div className="col-md-6">
              <div className="gSmidimg upgrade-img d-flex justify-content-center align-items-center">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/globalmidPlane.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GlobalServiceMidBanner;
